import { Box, Container, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { themeBlue } from "../../../utils/colorTheme";
import CustomTabs from "../../../component/CustomTabs/CustomTabs";
import VendorProfileTab from "../VendorProfileNestedPage/VendorProfileTab";
import VendorAccountTab from "../VendorProfileNestedPage/VendorAccountTab";
import VendorJobsTab from "../VendorProfileNestedPage/VendorJobsTab";
import { IoArrowBack } from "react-icons/io5";

const VendorProfile = () => {
  const navigate = useNavigate();

  const tabs = [
    { label: "Profile", content: <VendorProfileTab /> },
    { label: "Jobs", content: <VendorJobsTab /> },
    { label: "Account", content: <VendorAccountTab /> },
  ];

  return (
    <Stack sx={{ bgcolor: "#F8F9FA", minHeight: "100vh" }}>
      <Stack
        direction="row"
        alignItems="center"
        gap={2}
        sx={{ px: 3, py: 2.5 }}
      >
        <Box
          onClick={() => navigate("/vendor")}
          sx={{
            width: 36,
            height: 36,
            borderRadius: "10px",
            bgcolor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: "1px solid #f0f0f0",
            transition: "all 0.15s",
            "&:hover": { borderColor: "#ddd", bgcolor: "#f5f5f5" },
          }}
        >
          <IoArrowBack size={16} color="#555" />
        </Box>
        <Stack>
          <Typography sx={{ fontSize: "24px", fontWeight: 700, color: themeBlue }}>
            Pro Details
          </Typography>
          <Typography sx={{ fontSize: "13px", color: "#999", mt: 0.3 }}>
            View and manage pro information
          </Typography>
        </Stack>
      </Stack>
      <Container sx={{ maxWidth: { xl: "xl", lg: "lg", md: "md", sm: "sm", xs: "xs" } }}>
        <CustomTabs tabs={tabs} />
      </Container>
    </Stack>
  );
};

export default VendorProfile;
